import axiosInstance from './serverAxios'
import { ChildTenant } from 'src/types/user.type'

interface SwitchResponse {
  data: ChildTenant
  message: string
}

interface CurrentSelectionResponse {
  data: ChildTenant | null
}

interface ClearSelectionResponse {
  message: string
}

class TenantService {
  /**
   * Get list of available child tenants
   */
  async getChildren(): Promise<ChildTenant[]> {
    const response = await axiosInstance.get<ChildTenant[]>('/v1/tenants/children')

    return response.data
  }

  /**
   * Switch to a specific child tenant
   * @param schemaName - The schema name of the child tenant (e.g., "bford")
   */
  async switchTenant(schemaName: string): Promise<SwitchResponse> {
    const response = await axiosInstance.post<SwitchResponse>('/v1/tenants/switch', {
      schemaName
    })

    return response.data
  }

  /**
   * Get currently selected child tenant
   */
  async getCurrentSelection(): Promise<ChildTenant | null> {
    const response = await axiosInstance.get<CurrentSelectionResponse>('/v1/tenants/current-selection')

    return response.data.data
  }

  /**
   * Clear child tenant selection
   */
  async clearSelection(): Promise<void> {
    await axiosInstance.delete<ClearSelectionResponse>('/v1/tenants/clear-selection')
  }
}

export default new TenantService()
